import request from '@/utils/request'


// 查询订单选项列表
export function listOrderOption(query) {
  return request({
    url: '/user/order-option/list',
    method: 'get',
    params: query
  })
}

// 查询订单选项分页
export function pageOrderOption(query) {
  return request({
    url: '/user/order-option/page',
    method: 'get',
    params: query
  })
}

// 查询订单选项详细
export function getOrderOption(data) {
  return request({
    url: '/user/order-option/detail',
    method: 'get',
    params: data
  })
}

// 新增订单选项
export function addOrderOption(data) {
  return request({
    url: '/user/order-option/add',
    method: 'post',
    data: data
  })
}

// 修改订单选项
export function updateOrderOption(data) {
  return request({
    url: '/user/order-option/edit',
    method: 'post',
    data: data
  })
}

// 删除订单选项
export function delOrderOption(data) {
  return request({
    url: '/user/order-option/delete',
    method: 'post',
    data: data
  })
}
